import { render, staticRenderFns } from "./important.vue?vue&type=template&id=030a5f6c&scoped=true&"
import script from "./important.vue?vue&type=script&lang=js&"
export * from "./important.vue?vue&type=script&lang=js&"
import style0 from "./important.vue?vue&type=style&index=0&id=030a5f6c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030a5f6c",
  null
  
)

export default component.exports